import { useEffect } from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { getMachines, updateJackpotForMachine, updateJackpotValues } from "../../services/services";
import { useState } from "react";
import Modal from 'react-bootstrap/Modal';
import SweetAlert from "react-bootstrap-sweetalert";

function ViewMachines() {

	const [mstMachines, setMstMachines] = useState([]);
	const [showJackpotModal, setShowJackpotModal] = useState(false);
	const [selectedMachine, setSelectedMachine] = useState({});
	const [jackpotValues, setJackpotValues] = useState({
		jackpot_1: "",
		jackpot_2: "",
		jackpot_3: ""
	});
	const [showAlert, setShowAlert] = useState(false);

	useEffect(() => {
		getMachines((response) => {
			// console.log(JSON.parse(response.data[1].jackpot_value))
			setMstMachines(response.data)
		})
	}, [])

	const filterJackpot = (data) => {
		return parseInt(data) === 1 ?
			<span style={{ color: 'lightgreen', fontWeight: 'bold' }}>Yes</span>
			:
			<span style={{ color: 'red', fontWeight: 'bold' }}>No</span>
	}

	const updateJackMachineStatus = (machineId, clientId, checked) => {
		let reqBody = {
			client_id: clientId,
			machine_id: machineId,
			is_jackpot: checked ? 1 : 0
		}
		updateJackpotForMachine(reqBody, (response) => {
			setMstMachines(response.data)
		})
	}

	const handleShow = (machine) => {
		setSelectedMachine(machine);
		let json = machine.jackpot_value ? JSON.parse(machine.jackpot_value) : ''
		setJackpotValues({
			jackpot_1: json.jackpot_1 ?? "",
			jackpot_2: json.jackpot_2 ?? "",
			jackpot_3: json.jackpot_3 ?? ""
		});
		setShowJackpotModal(true);
	}

	const handleClose = () => {
		setShowJackpotModal(false);
		setSelectedMachine({});
	}

	const handleJackpotInputChange = (e) => {
		const { name, value } = e.target;
		setJackpotValues(prev => ({ ...prev, [name]: value }));
	}

	const handleSaveJackpotValues = () => {
		let reqBody = {
			client_id: selectedMachine.client_id,
			machine_id: selectedMachine.id,
			jackpot_1: jackpotValues.jackpot_1,
			jackpot_2: jackpotValues.jackpot_2,
			jackpot_3: jackpotValues.jackpot_3
		}

		updateJackpotValues(reqBody, (response) => {
			setShowAlert(true)
			setMstMachines(response.data.data)
			handleClose();
		})
	}

	return (
		<>
			<Row>
				<Col>
					{mstMachines.length > 0 ?
						<Table>
							<thead>
								<tr>
									<th>ID</th>
									<th>Machine Name</th>
									<th>Client Name</th>
									<th>Jackpot 1</th>
									<th>Jackpot 2</th>
									<th>Jackpot 3</th>
									<th>Jackpot 4</th>
									<th>Jackpot Status</th>
									<th>Machine Registered Date</th>
									<th>Jackpot Value</th>
								</tr>
							</thead>
							<tbody>
								{mstMachines.map(machine => (
									<tr key={machine.id}>
										<td>{machine.id}</td>
										<td>{machine.machine_name}</td>
										<td>{machine.client_name}</td>
										<td>{filterJackpot(machine.jackpot_1)}</td>
										<td>{filterJackpot(machine.jackpot_2)}</td>
										<td>{filterJackpot(machine.jackpot_3)}</td>
										<td>{filterJackpot(machine.jackpot_4)}</td>
										<td>
											<Form>
												<Form.Check
													type="switch"
													id={`customswitch${machine.id}`}
													checked={parseInt(machine.is_jackpot) === 1}
													onChange={(e) => updateJackMachineStatus(machine.id, machine.client_id, e.target.checked)}
												/>
											</Form>
										</td>
										<td>{machine.created_time}</td>
										<td>
											<Button variant="primary" onClick={() => handleShow(machine)}>
												Update
											</Button>
										</td>
									</tr>
								))}
							</tbody>
						</Table>
						:
						<></>
					}
				</Col>
			</Row>

			<Modal backdrop="static" show={showJackpotModal} onHide={handleClose}>
				<Modal.Header closeButton>
					<Modal.Title>Update Jackpot Values - {selectedMachine.machine_name}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form>
						<Form.Group className="mb-3" controlId="formJackpot1">
							<Form.Label>Jackpot 1</Form.Label>
							<Form.Control
								type="text"
								name="jackpot_1"
								value={jackpotValues.jackpot_1}
								onChange={handleJackpotInputChange}
								placeholder="Enter Jackpot 1 Value"
							/>
						</Form.Group>
						<Form.Group className="mb-3" controlId="formJackpot2">
							<Form.Label>Jackpot 2</Form.Label>
							<Form.Control
								type="text"
								name="jackpot_2"
								value={jackpotValues.jackpot_2}
								onChange={handleJackpotInputChange}
								placeholder="Enter Jackpot 2 Value"
							/>
						</Form.Group>
						<Form.Group className="mb-3" controlId="formJackpot3">
							<Form.Label>Jackpot 3</Form.Label>
							<Form.Control
								type="text"
								name="jackpot_3"
								value={jackpotValues.jackpot_3}
								onChange={handleJackpotInputChange}
								placeholder="Enter Jackpot 3 Value"
							/>
						</Form.Group>
					</Form>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleClose}>
						Close
					</Button>
					<Button variant="primary" onClick={handleSaveJackpotValues}>
						Save Changes
					</Button>
				</Modal.Footer>
			</Modal>

			{showAlert ?
				<SweetAlert 
					title="Success"
					onConfirm={()=>setShowAlert(false)}
				/>
				:
				<></>
			}
		</>
	);
};

export default ViewMachines;